/** @jsxImportSource @emotion/react */
import { Interpolation, Theme, css } from "@emotion/react";
import styled from "@emotion/styled";
import { theme } from "styles/theme";
import { TMember } from "types/user.types";
import Avatar from "uis/avatar";

const MemberContainer = styled.div`
    display: flex;
    align-items: center;
    padding: 12px 24px;
    border-radius: 10px;
    border-bottom: 1px solid var(--neutral-100, #eef1f3);
    gap: 8px;
`;

const NameField = styled.p<{ isDisabled: boolean }>`
    color: ${(props) => (props.isDisabled ? theme.neutral300 : theme.neutral800)};
    font-size: 16px;
    font-weight: 400;
`;

const EmailField = styled.p<{ isDisabled: boolean }>`
    font-size: 12px;
    color: ${(props) => (props.isDisabled ? theme.neutral300 : theme.neutral500)};
    font-weight: 400;
`;

const DeleteBtn = styled.p`
    padding: 10px 0;
    color: ${theme.primary500};
    font-size: 12px;
    font-weight: 600;
    margin-left: auto;

    cursor: pointer;
    &:hover {
        font-weight: 800;
    }
`;

export default function SearchManagerItem({
    member,
    allowDelete = false,
    isDisabled = false,
    onDelete = () => {},
    onClick = () => {},
    styles,
    rightRender,
}: {
    member: TMember;
    allowDelete?: boolean;
    isDisabled?: boolean;
    onDelete?: () => void;
    onClick?: () => void;
    styles?: {
        container?: Interpolation<Theme>;
    };
    rightRender?: () => JSX.Element | null;
}) {
    return (
        <MemberContainer css={styles?.container} onClick={onClick}>
            <Avatar 
                image={member.image} 
                size={40} 
                styles={{opacity: isDisabled ? 0.5 : 1}}
            />
            <div
                css={css`
                    display: flex;
                    flex-direction: column;
                `}
            >
                <NameField isDisabled={isDisabled}>{member.nickname}</NameField>
                <EmailField isDisabled={isDisabled}>{member.email}</EmailField>
            </div>
            {allowDelete ? <DeleteBtn onClick={() => onDelete()}>삭제하기</DeleteBtn> : null}
            {rightRender ? rightRender() : null}
        </MemberContainer>
    );
}
